// extracted by mini-css-extract-plugin
export default {"contenedorForm":"GenerarUsuariosComponent_contenedorForm__HZ9Um","tituloForm":"GenerarUsuariosComponent_tituloForm__gfbLl","error":"GenerarUsuariosComponent_error__be7JA"};